<p-dialog
  [(visible)]="dialogVisible"
  [header]="currentStep === 0 ? (('select.assets' | transloco) + ' (1/2)') : (('select.measurements' | transloco) + ' (2/2)')"
  [style]="{ width: '90vw' }"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  (onHide)="visibleChange.emit(false)"
  appendTo="body"
>
  <div *ngIf="dialogVisible">
    <app-assets-step
      *ngIf="currentStep === 0"
      [(assetSelection)]="assetSelection"
      [(assetFilters)]="assetFilters"
      [tenant]="tenant"
      [organization]="organization"
      [selectionMode]="selectionMode"
      (assetSelectionChange)="updateAssetMeasurementSelection($event)"
    ></app-assets-step>
    <app-asset-measurements-step
      *ngIf="currentStep === 1"
      [(assetMeasurementSelection)]="assetMeasurementSelection"
      [(assetMeasurementFilters)]="assetMeasurementFilters"
      [tenant]="tenant"
      [selectionMode]="selectionMode"
      [assetSelection]="assetSelection"
    ></app-asset-measurements-step>
  </div>

  <div class="flex justify-content-between pt-4">
    <div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="closeWithoutSaving()"
        pButton
        class="mr-2 p-button-danger"
      ></button>
    </div>
    <div class="flex justify-content-end">
      <button
        *ngIf="currentStep === 0"
        [label]="'common.next' | transloco"
        [disabled]="!assetSelection || assetSelection.length === 0"
        [class.p-button-danger]="selectionMode === 'multiple' && assetSelection.length > 100"
        [pTooltip]="'error.tooMany.assets' | transloco"
        [tooltipDisabled]="selectionMode === 'single' || assetSelection.length <= 100"
        (click)="(selectionMode === 'single' || assetSelection.length <= 100) ? currentStep = currentStep + 1 : ''"
        pButton
        icon="pi pi-chevron-right"
        class="mr-2"
        iconPos="right"
      ></button>
      <button
        *ngIf="currentStep === 1"
        [label]="'common.previous' | transloco"
        (click)="currentStep = currentStep - 1"
        pButton
        icon="pi pi-chevron-left"
        class="mr-2"
        iconPos="left"
      ></button>
      <div *ngIf="currentStep === 1">
        <button
          [label]="'common.select' | transloco"
          [disabled]="!assetMeasurementSelection || assetMeasurementSelection.length === 0"
          (click)="saveAndClose()"
          pButton
          icon="pi pi-check"
          iconPos="right"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>
